/**
 * ATENA CONSULTING — header.js
 * jQuery + GSAP
 *
 * Gestisce:
 * 1. Navbar scroll solid
 * 2. Menu hamburger (GSAP timeline)
 * 3. Sidebar consulenza
 * 4. Overlay condiviso
 */

import { gsap } from "gsap";

const header = () => {

$(() => {

  // ─────────────────────────────
  // ELEMENTI
  // ─────────────────────────────
  const $body        = $('body');
  const $navbar      = $('.navbar');
  const $toggler     = $('.navbar-toggler');
  const $topbar      = $('.header-top');
  const $links       = $topbar.find('.nav-link');

  const $consulenza  = $('#menu-item-consulenza');
  const $sidebar     = $('.sidebar-consulenza');
  const $sidebarClose= $('.sidebar-consulenza__close');

  // overlay
  let $overlay = $('.header-overlay');
  if (!$overlay.length) {
    $overlay = $('<div class="header-overlay"></div>').appendTo('body');
  }


  // ─────────────────────────────
  // 1. NAVBAR SCROLL
  // ─────────────────────────────
  $(window).on('scroll.navbar', function () {
    const scrolled = $(this).scrollTop() > 20;
    $navbar.toggleClass('is-scrolled', scrolled);
  });


  // ─────────────────────────────
  // 2. MENU HAMBURGER (GSAP)
  // ─────────────────────────────

  let menuOpen = false;

  const menuTL = gsap.timeline({
    paused: true,
    defaults: { ease: "power3.out" }
  });


  // hamburger → X
  menuTL.to(".toggler-icon:nth-child(1)", {
    y: 6.5,
    rotate: 45,
    duration: 0.35
  }, 0);

  menuTL.to(".toggler-icon:nth-child(2)", {
    opacity: 0,
    scaleX: 0,
    duration: 0.2
  }, 0);

  menuTL.to(".toggler-icon:nth-child(3)", {
    y: -6.5,
    rotate: -45,
    duration: 0.35
  }, 0);


 


  // overlay fade
  menuTL.to($overlay, {
    scaleY: 1,
    duration: 0.45,
    ease: "power2.out",
    onStart: () => $overlay.css("pointer-events","all"),
    onReverseComplete: () => $overlay.css("pointer-events","none")
  }, 0);

   // topbar slide
  menuTL.to($topbar, {
    y: 0,
    duration: 0.7,
    ease: "power4.out"
  }, 0.3);


  // reveal menu items
  menuTL.fromTo(
    $links,
    {
      x: -80,
      opacity: 0
    },
    {
      x: 0,
      opacity: 1,
      duration: 0.65,
      ease: "power3.out",
      stagger: 0.3
    },
    0.8
  );

  menuTL.to(".menu-mask", {
    clipPath: "inset(0 0% 0 0)",
    duration: 0.6,
    stagger: 0.08
  }, 0.8);

  menuTL.to("#menu_top_small", {
    opacity: 1,
    duration: 0.6,
    stagger: 0.08
  }, 0.8);

  // menuTL.from("#menu_top_small .menu-mask", {
  //   clipPath: "inset(0 0% 0 0)",
  //   duration: 0.6,
  //   stagger: 0.08
  // }, 0.8);


  // toggle menu
  $toggler.on('click.menu', function(e){

    e.preventDefault();

    if(menuOpen){
      menuTL.reverse();
      $toggler.attr('aria-expanded','false');
    }
    else{
      menuTL.play();
      $toggler.attr('aria-expanded','true');
    }

    menuOpen = !menuOpen;

  });



  // ─────────────────────────────
  // 3. SIDEBAR CONSULENZA
  // ─────────────────────────────

  let sidebarOpen = false;

  function openSidebar(){

    sidebarOpen = true;
    $sidebar.addClass('is-open');

    if(menuOpen){
      menuTL.reverse();
      menuOpen = false;
    }

    $overlay.addClass('is-visible');

  }

  function closeSidebar(){

    sidebarOpen = false;
    $sidebar.removeClass('is-open');

    if(!menuOpen){
      $overlay.removeClass('is-visible');
    }

  }

  $consulenza.on('click.sidebar', function(e){

    e.preventDefault();

    sidebarOpen ? closeSidebar() : openSidebar();

  });

  $sidebarClose.on('click.sidebar', function(){
    closeSidebar();
  });



  // ─────────────────────────────
  // 4. OVERLAY CLICK
  // ─────────────────────────────

  $overlay.on('click.overlay', function(){

    if(menuOpen){
      menuTL.reverse();
      menuOpen = false;
    }

    if(sidebarOpen){
      closeSidebar();
    }

  });



  // ─────────────────────────────
  // 5. ESC KEY
  // ─────────────────────────────

  $(document).on('keydown.header', function(e){

    if(e.key === "Escape"){

      if(menuOpen){
        menuTL.reverse();
        menuOpen = false;
      }

      if(sidebarOpen){
        closeSidebar();
      }

    }

  });

});

};

export default header;